import React from "react";

const TwitterSocialIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.58561 14.7924C11.901 14.7924 14.2606 11.2165 14.2606 8.11745C14.2606 8.01528 14.2606 7.91311 14.2557 7.81581C14.713 7.48498 15.112 7.07144 15.4282 6.59952C15.0098 6.7844 14.5574 6.91089 14.0806 6.96927C14.5671 6.67736 14.9368 6.22004 15.112 5.67028C14.6595 5.93786 14.1584 6.13247 13.6233 6.2395C13.1951 5.78218 12.587 5.5 11.9107 5.5C10.6166 5.5 9.56572 6.55087 9.56572 7.845C9.56572 8.02987 9.58518 8.20988 9.62897 8.38016C7.67805 8.28286 5.95092 7.34875 4.79302 5.92813C4.59355 6.27356 4.47678 6.67736 4.47678 7.1055C4.47678 7.91798 4.89032 8.63802 5.52279 9.05642C5.13844 9.04669 4.77842 8.93966 4.46219 8.76451C4.46219 8.77424 4.46219 8.78397 4.46219 8.7937C4.46219 9.93214 5.2698 10.876 6.345 11.0949C6.15039 11.1484 5.94119 11.1776 5.72713 11.1776C5.57631 11.1776 5.43035 11.163 5.2844 11.1338C5.58117 12.0679 6.44717 12.7442 7.47371 12.7637C6.67096 13.3913 5.65901 13.7659 4.55949 13.7659C4.36975 13.7659 4.18488 13.7561 4 13.7318C5.02654 14.4032 6.26229 14.7924 7.58561 14.7924Z",
  fill: "#1AB7EA"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TwitterSocialIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;